// COMPONENT: Product cart confirmation connects Story's AJAX success state to the inline page-cart message.
(() => {
  const addButtonSelector = '[data-add-to-cart]';
  const confirmationSelector = '[data-product-cart-confirmation]';
  const quantitySelector = '[data-product-cart-confirmation-quantity]';
  const observedButtons = new WeakSet();

  const updateConfirmation = (button) => {
    const form = button.closest('form');
    const confirmation = button.closest('[data-add-action-wrapper]')?.querySelector(confirmationSelector);

    if (!form || !confirmation) {
      return;
    }

    if (button.classList.contains('loading')) {
      confirmation.hidden = true;
      return;
    }

    if (!button.classList.contains('has-success')) {
      return;
    }

    const quantity = form.querySelector('[name="quantity"]')?.value || '1';
    confirmation.querySelector(quantitySelector).textContent = quantity;
    confirmation.hidden = false;
  };

  const observeButton = (button) => {
    if (observedButtons.has(button)) {
      return;
    }

    observedButtons.add(button);
    new MutationObserver(() => updateConfirmation(button)).observe(button, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const observeButtons = (root) => {
    if (root.matches?.(addButtonSelector)) {
      observeButton(root);
    }

    root.querySelectorAll?.(addButtonSelector).forEach(observeButton);
  };

  const initialize = () => {
    observeButtons(document);

    // VARIANTS: Story morphs product form children when a variant changes, so newly rendered buttons must be observed.
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            observeButtons(node);
          }
        });
      });
    }).observe(document.body, {childList: true, subtree: true});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
})();
